import { Box, Container, Grid2 as Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { howItWorksSteps } from '../content/howItWorksSteps';
import HowItWorksTimeline from '../components/how-it-works/HowItWorksTimeline';
import StepDetailPanel from '../components/how-it-works/StepDetailPanel';
import type { HowItWorksStep } from '../types/howItWorks';

const HowItWorksPage: React.FC = () => {
  const [selectedStepId, setSelectedStepId] = useState<string | null>(null);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const selectedStep: HowItWorksStep | null = selectedStepId
    ? howItWorksSteps.find((s) => s.id === selectedStepId) ?? null
    : null;

  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="lg">
        <Typography variant="h4" component="h1" sx={{ mb: 1, fontWeight: 600 }}>
          How It Works
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Click a step to see details. UI = webapp; Notification = email/SMS; Backend = Django API or internal.
        </Typography>

        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: isDesktop ? 7 : 12 }}>
            <HowItWorksTimeline
              steps={howItWorksSteps}
              selectedStepId={selectedStepId}
              onSelectStep={setSelectedStepId}
            />
          </Grid>
          {isDesktop && (
            <Grid size={5} sx={{ position: 'sticky', top: 24, alignSelf: 'flex-start', maxWidth: 360 }}>
              <StepDetailPanel step={selectedStep} />
            </Grid>
          )}
          {!isDesktop && selectedStep && (
            <Grid size={12}>
              <StepDetailPanel step={selectedStep} onClose={() => setSelectedStepId(null)} />
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItWorksPage;
